import {Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';
import {ConfirmModal} from "../confirm-modal/confirm-modal.component";
import {SimpleModalComponent} from "ngx-simple-modal";

type ArchiveConfirmEvent = {
  result: boolean;
  reason?: string;
}

@Component({
  selector: 'app-archive-confirm-modal',
  templateUrl: './confirm-reason-modal.component.html',
  styleUrls: ['./confirm-reason-modal.component.sass']
})
export class ConfirmReasonModalComponent extends SimpleModalComponent<ConfirmModal, ArchiveConfirmEvent> implements ConfirmModal {
  title: string = 'Megerősítés';
  message: string = 'Biztosan végre szeretné hajtani a műveletet?';
  description?: string = undefined;
  cancelText: string = 'Mégse';
  confirmText: string = 'Megerősítés';
  cancelClass: string = 'btn-dark';
  confirmClass: string = 'btn-primary';

  @Output() onConfirm: EventEmitter<ArchiveConfirmEvent> = new EventEmitter<ArchiveConfirmEvent>();
  @ViewChild('reason') reason!: ElementRef;

  constructor() {
    super();
  }

  confirm() {
    const reason = (this.reason.nativeElement as HTMLTextAreaElement).value;
    this.result = {
      result: true,
      reason
    };
    this.close();

    this.onConfirm.emit(this.result);
  }
}
